import { Nullable } from '@core/helpers';

export enum RequestObdStatus {
  HasOBD2 = 1,
  HasNoAccessToSocket = 2,
  HasSocketButNotOBD2 = 3,
  HasNoSocket = 4,
}

export type UpdateRequestObdDataPayload = {
  obdStatus: Nullable<RequestObdStatus>;
  obdComment: Nullable<string>;
  obdReadSuccess?: Nullable<boolean>;
};
